import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { contractingKeys } from "@/lib/query-keys";
import type { QualificationStatus } from "@/types/domain";

/**
 * El análisis de calificación de la empresa y, con cruce automático, de cada
 * línea. Mientras corre se pregunta seguido, como la lectura de documentos; el
 * resto del tiempo lo refrescan las acciones que lo cambian.
 */
export function useQualificationStatus() {
  return useQuery<QualificationStatus>({
    queryKey: contractingKeys.qualification(),
    queryFn: () => fetchToBackend("/organization/qualification"),
    refetchInterval: (query) => (query.state.data?.running ? 5000 : false),
  });
}
